import type { ReactNode } from 'react';
import { LoadingState } from '@reflex/ui/components/shared/LoadingState';
import { ErrorState } from '@reflex/ui/components/shared/ErrorState';

interface AsyncContentProps {
  isLoading: boolean;
  isError: boolean;
  loadingMessage?: string;
  errorMessage?: string;
  children: ReactNode;
}

/**
 * Renders loading / error / content states for async data.
 * Replaces the `isLoading ? <LoadingState/> : isError ? <ErrorState/> : children` ternary chain.
 */
export function AsyncContent({
  isLoading,
  isError,
  loadingMessage,
  errorMessage,
  children,
}: AsyncContentProps) {
  if (isLoading) return <LoadingState message={loadingMessage} />;
  if (isError) return <ErrorState message={errorMessage} />;
  return <>{children}</>;
}
